import UpdateTransferReturn from "../../../../components/@documents/transfer_returns/UpdateTransferReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnUpdatePage() {

    return (
        <UpdateTransferReturn 
            routeType={routeTypes.retail}
        />
    )
}